export const PRICING_CONSTANTS = {
    'gemini-1.5-flash': { input: 0.075, output: 0.30, name: 'Gemini 1.5 Flash' },
    'gemini-1.5-pro': { input: 1.25, output: 5.00, name: 'Gemini 1.5 Pro' },
    'gemini-1.0-pro': { input: 0.50, output: 1.50, name: 'Gemini 1.0 Pro' },
    'gemini-2.5-flash-lite': { input: 0.075, output: 0.30, name: 'Gemini 1.5 Flash' }, // Fallback to Flash pricing
};

export const calculateCost = (model, inputTokens, outputTokens) => {
    // Basic normalization of model string to find match
    let pricing = PRICING_CONSTANTS['gemini-1.5-flash']; // Default

    if (model) {
        if (model.includes('pro')) pricing = PRICING_CONSTANTS['gemini-1.5-pro'];
        if (model.includes('1.0-pro')) pricing = PRICING_CONSTANTS['gemini-1.0-pro'];
        if (model.includes('flash')) pricing = PRICING_CONSTANTS['gemini-1.5-flash'];
    }

    const inputCost = (inputTokens / 1000000) * pricing.input;
    const outputCost = (outputTokens / 1000000) * pricing.output;

    return {
        inputCost,
        outputCost,
        totalCost: inputCost + outputCost,
        pricing,
        modelName: pricing.name
    };
};

export const INR_RATE = 90.6;
